<div class="d-flex flex-column h-100">
  <!-- Header — only when headerTitle is passed (phone-update success) -->
  <div class="success-header px-4" *ngIf="headerTitle">
    <div class="d-flex justify-content-between align-items-center h-100">
      <div class="header-placeholder"></div>
      <h1 class="success-header-title m-0">{{ headerTitle }}</h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>
  </div>

  <div class="mx-4 mt-3 modal-main">
    <div class="header row align-items-center">
      <div class="col d-flex justify-content-end pb-3" *ngIf="!headerTitle">
        <img
          src="/assets/svg/ico-hamburger-close.svg"
          class="cross-button pointer-cursor"
          (click)="closeDialog()"
        />
      </div>

      <div
        class="modal-title w-100 d-flex flex-row justify-content-center align-items-center"
      >
        <p>{{ SuccessMessage }}</p>
      </div>

      <div
        class="w-100 d-flex flex-row justify-content-center align-items-center icon-style"
      >
        <img
          src="/assets/svg/ico-completed-check.svg"
          alt="completed account setting"
        />
      </div>

      <div
        class="w-100 d-flex flex-row justify-content-center align-items-center"
      >
        <p class="completed-label">{{ "COMPLETED" | translate }}</p>
      </div>
    </div>
    <div class="row mt-4">
      <button
        class="btn btn-danger px-3 w-100 save-btn"
        type="button"
        (click)="closeDialog()"
      >
        {{ "DONE" | translate }}
      </button>
    </div>
  </div>
</div>
